import {
    Drawer,
    DrawerCloseButton,
    DrawerContent,
    DrawerOverlay,
    Flex,
    IconButton,
} from "@chakra-ui/react";

import { Sidebar } from "@components/Sidebar/Sidebar";
import { SidebarProps } from "@components/Sidebar/Sidebar";
import { useMobileMenuState } from "@components/MobileTopBar/useMobileMenuState";
import { config } from "@/config/config";
import { $g1Color } from "@/theme/G1Style";
import { G1Icon } from "@utils/icons";

export interface MobileTopBarProps extends SidebarProps {}

export const MobileTopBar = (props: MobileTopBarProps) => {
    const { activeItemKey, adminPage, onSearch } = props ;
    const { isOpen, onClose, onOpen } = useMobileMenuState() ;

    return (
        <Flex
            align="center"
            justify="start"
            py="2"
            px="4"
            bg={$g1Color('topbar.bg')}
            color={$g1Color('topbar.write')}
            display={{ base: "flex", md: "none" }}
            borderBottomWidth="1px"
        >
            <IconButton
                onClick={onOpen}
                variant="unstyled"
                display="flex"
                cursor="pointer"
                aria-label="Menu"
                mr="2%"
                icon={<G1Icon.MenuBurger fontSize="1.5rem" />}
                color="currentColor"
            />
            {config.app.title}
            <Drawer size="md" placement="left" isOpen={isOpen} blockScrollOnMount={false} onClose={onClose}>
                <DrawerOverlay />
                <DrawerContent shadow="none" position="relative" maxW="80%">
                    <DrawerCloseButton position="absolute" />
                    <Sidebar
                        width="full"
                        height="full"
                        border="0"
                        activeItemKey={activeItemKey}
                        adminPage={adminPage}
                        onSearch={onSearch}
                    />
                </DrawerContent>
            </Drawer>
        </Flex>
    ) ;
} ;